import { render, staticRenderFns } from "./StyleManagerEditor.vue?vue&type=template&id=e4c08b36&scoped=true"
import script from "./StyleManagerEditor.vue?vue&type=script&lang=js"
export * from "./StyleManagerEditor.vue?vue&type=script&lang=js"
import style0 from "./StyleManagerEditor.vue?vue&type=style&index=0&id=e4c08b36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c08b36",
  null
  
)

export default component.exports